import { render } from "./PartnerLibertas.vue?vue&type=template&id=4ce12584"
import script from "./PartnerLibertas.vue?vue&type=script&lang=js"
export * from "./PartnerLibertas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__